import { Currency, CURRENCY_SYMBOLS } from './supabase';

export function convertDistance(value: number, from: 'km' | 'miles', to: 'km' | 'miles'): number {
  if (from === to) return value;
  if (from === 'km' && to === 'miles') return value * 0.621371;
  return value * 1.60934;
}

export function convertVolume(value: number, from: 'liters' | 'gallons', to: 'liters' | 'gallons'): number {
  if (from === to) return value;
  if (from === 'liters' && to === 'gallons') return value * 0.264172;
  return value * 3.78541;
}

export function formatDistance(value: number, unit: 'km' | 'miles'): string {
  const rounded = Math.round(value);
  return `${rounded.toLocaleString()} ${unit}`;
}

export function formatVolume(value: number, unit: 'liters' | 'gallons'): string {
  return `${value.toFixed(2)} ${unit === 'liters' ? 'L' : 'gal'}`;
}

export function convertAmount(value: number, from: Currency, to: Currency): number {
  if (from === to) return value;
  return value;
}

export function formatCurrency(value: number, currency: Currency, symbol?: string, precision: number = 2): string {
  const safeCurrency = (currency || '').toUpperCase() as Currency;
  const currencySymbol = symbol || CURRENCY_SYMBOLS[safeCurrency] || (safeCurrency ? safeCurrency : '');

  if (safeCurrency === 'JPY') {
    return `${currencySymbol}${Math.round(value).toLocaleString()}`;
  }

  const formatted = value.toFixed(precision);

  if (safeCurrency === 'USD' || safeCurrency === 'CAD' || safeCurrency === 'AUD') {
    return `${currencySymbol}${formatted}`;
  }

  return `${formatted} ${currencySymbol}`;
}

export { CURRENCY_SYMBOLS };
